import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`

export const ScrollArea = styled.div<{ $isExpanded: boolean }>`
	max-height: 600px;
	overflow-y: auto;
	padding: ${props =>
		props.$isExpanded ? '0 20px 30px 20px' : '0 20px 0px 20px'};
	border-radius: 16px;

	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 4px;
	}
`

export const DateGroup = styled.div`
	animation: ${fadeIn} 0.3s ease;
	border-bottom: 1px solid #bcbcbc;
`

export const DateLabel = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-size: 12px;
	color: #aaa;
	padding: 16px 0 8px;
	border-bottom: 1px solid #bcbcbc;
`

export const NotificationCard = styled.div`
	padding: 12px 0;
	border-bottom: 1px solid #bcbcbc;

	&:last-child {
		border-bottom: none;
	}

	@media(max-width: 768px){
	padding: 8px 0;
	}
`

export const CardHeader = styled.div<{$isExpanded?: boolean}>`
	display: flex;
	align-items: center;
	gap: 12px;
     margin-bottom: ${props =>
		props.$isExpanded ?  ' 10px' : '8px'};
`

export const CardMeta = styled.div`
	flex: 1;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 8px;
`

export const CardTitle = styled.div<{$isExpanded?: boolean}>`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #000;

  ${({ $isExpanded }) =>
    !$isExpanded &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  `}
  

  ${({ $isExpanded }) =>
    $isExpanded &&
    `
    display: block;
    overflow: visible;
    white-space: normal;
  `}
`

export const CardTime = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-size: 12px;
	color: #aaa;
	white-space: nowrap;
	flex-shrink: 0;
`

export const CardText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	line-height: 122%;
	letter-spacing: 0.01em;
	
	color: #817e7e;

	

	@media(max-width: 425px) {
	 font-size: 11px;
	}
`

export const ScrollTopBtn = styled.button`
	position: absolute;
	bottom: 0;
	float: right;
	margin: 8px 0 0;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #fff;
	border: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #01924f;
	font-size: 24px;
`

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 99;
`

export const NotificationsWrapper = styled.div<{
	$isExpanded: boolean
	$isMobile: boolean
}>`
	margin: 0 auto;
	background: #fff;
	box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	overflow: visible;
	position: ${props =>
		props.$isMobile && props.$isExpanded ? 'absolute' : 'absolute'};
	top: 120px;
	left: auto;
	right: 10px;
	z-index: 100;
	width: ${props =>
		props.$isMobile && props.$isExpanded ? 'calc(100vw - 40px)' : '380px'};
	max-width: 380px;
	transition: all 0.3s ease;

	@media(max-width: 768px){
	right: 10px;
	top: 147px;
	width: ${props => props.$isExpanded ? '90%' : '340px'};
	}

	@media(max-width: 425px){
	width: ${props => props.$isExpanded ? '90%' : '280px'};
	}
	
`

export const ExpandBtn = styled.button<{ $isExpanded: boolean }>`
	position: absolute;
	bottom: -18px;
	right: 16px;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #fff;
	border: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #01924f;
	font-size: 20px;
	transform: rotate(${props => (props.$isExpanded ? '0deg' : '180deg')});
	transition: transform 0.3s ease;
	z-index: 101;
`
